import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { Input } from '@factorialco/f0-react/dist/experimental'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import DirectUploader from 'modules/trainings/components/Files/Uploaders/DirectUploader'
import { ContentEditorProps } from 'modules/trainings/components/content/types'
import { AttachedFile } from 'modules/trainings/lib/content/AttachedFile'
import { VideoBlock } from 'modules/trainings/lib/content/VideoBlock'

export const VideoBlockEditor = observer(
  ({ contentItem, trainingId }: ContentEditorProps<VideoBlock>) => {
    return (
      <>
        <Input
          label={i18n.t('trainings.content.block.video.title_label')}
          onChange={(value: string) => {
            contentItem.title = value
          }}
          placeholder={i18n.t('trainings.content.block.video.title_placeholder')}
          value={contentItem.title}
          required
        />

        <Box className="gap-2">
          <Box className="gap-1">
            <Text size="200" className="text-f1-foreground-secondary" weight="medium">
              {i18n.t('trainings.content.block.video.upload_label')}
            </Text>
            <Text size="100" className="text-base text-f1-foreground-secondary">
              {i18n.t('trainings.content.block.video.upload_description')}
            </Text>
          </Box>
          <DirectUploader
            onUpload={async (uploadData) => {
              contentItem.video = AttachedFile.fromUpload(
                uploadData.file,
                uploadData.signedId || ''
              )
            }}
            onDelete={() => {
              contentItem.video.clear()
            }}
            description={i18n.t('trainings.content.block.video.upload_file_description')}
            fileTypes={['video' as const]}
            resourceType={'Trainings::Training'}
            resourceId={String(trainingId)}
            initialFile={
              !contentItem.video.isEmpty() ? contentItem.video.toFileObject('video/mp4') : undefined
            }
          />
        </Box>
      </>
    )
  }
)
